<template>
  <div>
    <nav class="stick-top" style="top: 80px; background: var(--p4surface5, #0F0F0F);">
      <div class="nav nav-tabs border-b details-cal-pills" id="nav-tab" role="tablist">
        <a v-if="ltype == 'rent'" class="nav-item nav-link active" :id="'nav-rental-'+mode" style="background:none;" data-toggle="tab" :href="'#rental-'+mode" role="tab" aria-controls="nav-rental" aria-selected="true">Rental Calculator</a>
        <a v-if="ltype != 'rent'" class="nav-item nav-link active" :id="'nav-loan-'+mode" style="background:none;" data-toggle="tab" :href="'#loan-'+mode" role="tab" aria-controls="nav-loan" aria-selected="true">Loan Calculator</a>
        <a v-if="ltype != 'rent'" class="nav-item nav-link" :id="'nav-loan-check-'+mode" style="background:none;" data-toggle="tab" :href="'#loan-check-'+mode" role="tab" aria-controls="nav-loan-check" aria-selected="false">Loan Checker</a>
        <a v-if="ltype != 'rent'" class="nav-item nav-link" :id="'nav-legal-fee-'+mode" style="background:none;" data-toggle="tab" :href="'#legal-fee-'+mode" role="tab" aria-controls="nav-legal-fee" aria-selected="false">Legal Fee Calculator</a>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <!-- Rental calculator -->
      <div v-if="ltype == 'rent'" class="tab-pane fade show active" :id="'rental-'+mode" role="tabpanel" aria-labelledby="nav-rental">
        <div class="cal-results">
          <div class="p-4">
            <div class="cal-result-div">
              <div class="cal-subtitle">Total Payment</div>
              <div class="cal-redtitle mt-2">RM {{addComma(totalAmount)}}</div>
            </div>
          </div>
          <div class="border-t p-4">
            <div class="cal-title">Breakdown</div>
            <div class="row m-0">
              <div class="pl-0 col-7">
                <div class="mb-3">Agreement Charges</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold mb-3">RM {{addComma(agreeCharge)}}</div>
              </div>
            </div>
            <div class="row m-0">
              <div class="pl-0 col-7">
                <div class="mb-3">Stamp Duty</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold mb-3">RM {{addComma(stampDuty)}}</div>
              </div>
            </div>
            <div class="row m-0">
              <div class="pl-0 col-7">
                <div>Total Additional Copy</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold">RM {{addComma(totaladdCopy)}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="cal-form-container">
          <div class="cal-label">Monthly Rental Price</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="monthRent" class="filter-price-range">
          </div>

          <div class="cal-label">Tenancy Period</div> 
          <div class="filter-price-wrapper">
            <input type='number' v-model="tenanPeriod" class="filter-price-range">
            <span class="filter-price-rm w-auto ml-auto">years</span>
          </div>

          <div class="cal-label">Number of Additional Copies</div> 
          <div class="filter-price-wrapper">
            <input type='number' v-model="addCopy" class="filter-price-range">
            <span class="filter-price-rm w-auto ml-auto">copies</span>
          </div>

          <button @click="calculate" class="cal-btn">
            <span v-if="isloaded">Calculate</span>
            <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Loan calculator -->
      <div v-if="ltype != 'rent'" class="tab-pane fade show active" :id="'loan-'+mode" role="tabpanel" aria-labelledby="nav-loan">
        <div class="cal-results">
          <div class="p-4">
            <div class="cal-result-div">
              <div class="cal-subtitle">Monthly Loan Repayment</div>
              <div class="cal-redtitle mt-2">RM {{addComma(monthPay)}}</div>
            </div>
            <div class="row mx-0 mt-3">
              <div class="pl-0 col-7">
                <div class="cal-subtitle">Monthly Interest</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold">RM {{addComma(monthInt)}}</div>
              </div>
            </div>
          </div>
          <div class="border-t p-4">
            <div class="cal-title">Total</div>
            <div class="row m-0">
              <div class="pl-0 col-7">
                <div class="mb-3">Total Principal</div>
                <div class="mb-3">Total Interest</div>
                <div>Total Payment</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold mb-3">RM {{addComma(totalPrin)}}</div>
                <div class="font-weight-bold mb-3">RM {{addComma(totalInt)}}</div>
                <div class="font-weight-bold">RM {{addComma(totalPay)}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="cal-form-container">
          <div class="cal-label">Purchase Price</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="purcPrice" class="filter-price-range">
          </div>
          
          <div class="cal-label">Loan Amount (%)</div> 
          <div class="filter-price-wrapper">
            <input type='number' v-model="loanAm" class="filter-price-range" placeholder="E.g. 80  (of your loan amount)">
            <span class="filter-price-rm ml-auto">%</span>
          </div>

          <div class="cal-label">Loan Tenure</div> 
          <div class="filter-price-wrapper">
            <input type='number' v-model="loanTen" class="filter-price-range" placeholder="Number of years">
            <span class="filter-price-rm w-auto ml-auto">years</span>
          </div>

          <div class="cal-label">Interest Rate (%)</div> 
          <div class="filter-price-wrapper">
            <input type='number' v-model="intRate" class="filter-price-range">
            <span class="filter-price-rm ml-auto">%</span>
          </div>

          <div class="about-title mt-5">Optional (Monthly)</div>

          <div class="cal-label">MRTA</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="mrta" class="filter-price-range">
          </div>

          <button @click="calculate" class="cal-btn">
            <span v-if="isloaded">Calculate my Monthly Repayment</span>
            <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Loan Checker -->
      <div v-if="ltype != 'rent'" class="tab-pane fade" :id="'loan-check-'+mode" role="tabpanel" aria-labelledby="nav-loan-check">
        <div class="cal-results">
          <div class="p-4">
            <div class="cal-title">Debt Service Ratio</div>
            <div class="cal-table">
              <table>
                <thead>
                  <tr>
                    <th class="first">Bank DSR</th>
                    <th>Repayment Ability / Month (RM)</th>
                    <th>Estimated Loan Amount (RM)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="first">65%</td>
                    <td>{{addComma(DSR65)}}</td>
                    <td>{{addComma(LA65)}}</td>
                  </tr>
                  <tr>
                    <td class="first">75%</td>
                    <td>{{addComma(DSR75)}}</td>
                    <td>{{addComma(LA75)}}</td>
                  </tr>
                  <tr>
                    <td class="first">85%</td>
                    <td>{{addComma(DSR85)}}</td>
                    <td>{{addComma(LA85)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="border-t p-4">
            <div class="cal-title">Breakdown</div>
            <div class="row m-0">
              <div class="pl-0 col-7">
                <div class="mb-3">Total Expenses</div>
                <div>Net Income</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold mb-3">RM {{addComma(totalExp)}}</div>
                <div class="font-weight-bold">RM {{addComma(netIncome)}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="cal-form-container">
          <div class="cal-label">Monthly Gross Salary Income (RM / Month)</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="grossIncome" class="filter-price-range">
          </div>
          <div class="mt-2"><small>After EPF, Soscso, TAX and etc</small></div>

          <div class="about-title mt-5">Monthly Commitment</div>

          <div class="cal-label">Car Installment</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="carInst" class="filter-price-range">
          </div>

          <div class="cal-label">Credit Card</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="credCard" class="filter-price-range">
          </div>

          <div class="cal-label">Personal Loan</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="persLoan" class="filter-price-range">
          </div>

          <div class="cal-label">Others</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="loanchecker_otherS" class="filter-price-range">
          </div>

          <button @click="calculate" class="cal-btn">
            <span v-if="isloaded">Check my Loan Eligibility</span>
            <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </div>
      </div>

      <!-- Legal Fee calculator -->
      <div v-if="ltype != 'rent'" class="tab-pane fade" :id="'legal-fee-'+mode" role="tabpanel" aria-labelledby="nav-legal-fee">
        <div class="cal-results">
          <div class="p-4">
            <div class="cal-result-div">
              <div class="cal-subtitle">Grand Total</div>
              <div class="cal-redtitle mt-2">RM {{addComma(grandTotal)}}</div>
            </div>
          </div>
          <div class="border-t p-4">
            <div class="cal-title">Sales &amp; Purchase</div>
            <div class="row m-0">
              <div class="pl-0 col-7">
                <div class="mb-3">S&amp;P Legal Fee</div>
                <div class="mb-3">S&amp;P Stamp Duty</div>
                <div>Total</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold mb-3">RM {{addComma(spLegal)}}</div>
                <div class="font-weight-bold mb-3">RM {{addComma(spDuty)}}</div>
                <div class="font-weight-bold">RM {{addComma(spTotal)}}</div>
              </div>
            </div>
          </div>
          <div class="border-t p-4">
            <div class="cal-title">Loan</div>
            <div class="row m-0">
              <div class="pl-0 col-7">
                <div class="mb-3">Loan Legal Fee</div>
                <div class="mb-3">Loan Stamp Duty</div>
                <div>Total</div>
              </div>
              <div class="pr-0 col-5">
                <div class="font-weight-bold mb-3">RM {{addComma(loanLegal)}}</div>
                <div class="font-weight-bold mb-3">RM {{addComma(loanDuty)}}</div>
                <div class="font-weight-bold">RM {{addComma(loanTotal)}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="cal-form-container">
          <div class="cal-label">Purchase Price</div> 
          <div class="filter-price-wrapper">
            <span class="filter-price-rm">RM</span>
            <input type='number' v-model="propPrice" class="filter-price-range">
          </div>
          
          <div class="cal-label">Loan Amount</div> 
          <div class="filter-price-wrapper">
            <input type='number' v-model="moF" class="filter-price-range" placeholder="E.g. 80  (of your loan amount)">
            <span class="filter-price-rm ml-auto">%</span>
          </div>

          <button @click="calculate" class="cal-btn">
            <span v-if="isloaded">Calculate my Monthly Repayment</span>
            <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CalGroup',
    props: ['ltype', 'sale_price', 'rent_price', 'auction_price', 'mode'],
    data: function () {
      return {
        // Rental
        monthRent: null,
        tenanPeriod: null,
        addCopy: null,

        // Loan Calculator
        purcPrice: null,
        loanAm: null,
        loanTen: null,
        intRate: null,
        mrta: 0,

        // Loan Checker
        grossIncome: null,
        carInst: null,
        credCard: null,
        persLoan: null,
        loanchecker_otherS: null,

        // Legal Fees
        propPrice: null,
        moF: null,

        isloaded: true,
      }
    },
    mounted() {
      if (this.sale_price && this.ltype == 'sale') {
        this.purcPrice = this.sale_price;
        this.propPrice = this.sale_price;
      } else if (this.auction_price && this.ltype == 'auction') {
        this.purcPrice = this.auction_price;
        this.propPrice = this.auction_price;
      }

      if (this.rent_price) {
        this.monthRent = this.rent_price
      }

      this.tenanPeriod = 3;
      this.addCopy = 1;

      this.loanAm = 90;
      this.loanTen = 30;
      this.intRate = 5;

      this.grossIncome = 3000;
      this.carInst = 0;
      this.credCard = 0;
      this.persLoan = 0;
      this.loanchecker_otherS = 0;

      this.moF = 90;
    },
    computed: {
      // ------------------------ Rental Calculator ------------------
      agreeCharge() {
        if (this.monthRent <= 10000) {
          return Math.round(this.monthRent * 0.25);
        } else {
          return Math.round(2500 + (this.monthRent - 10000) * 0.20);
        }
      },
      taxable() {
        var tax = 0;
        if (this.tenanPeriod == 1) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 1
        } else if (this.tenanPeriod > 1 && this.tenanPeriod <= 3) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 3
        } else if (this.tenanPeriod > 3 && this.tenanPeriod <= 5) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 5
        } else if (this.tenanPeriod > 5) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 7
        }
        if (tax < 0) { tax = 0 }
        return tax
      },
      stampDuty() { return this.isEven(parseFloat(this.taxable))},
      totaladdCopy() { return this.addCopy * 10 },
      totalAmount() { return Math.round(parseFloat(this.agreeCharge) + parseFloat(this.stampDuty) + parseFloat(this.totaladdCopy)) },
      
      // ------------------------ Loan Calculator ------------------
      totalPrin() {
        return parseFloat(this.purcPrice * this.loanAm / 100) + parseFloat(this.mrta);
      },
      monthPay() {
        let x = this.intRate / 1200;
        let w = 12 * this.loanTen;
        let y = Math.pow((1 + x), w);
        return Math.round((parseFloat(this.totalPrin) * x) * (y) / (y - 1));
      },
      monthInt() {
        let x = this.intRate / 1200;
        let w = 12 * this.loanTen;
        return Math.round(parseFloat(this.totalInt) / w);
      },
      totalInt() {
        return Math.round(parseFloat(this.totalPay) - parseFloat(this.totalPrin));
      },
      totalPay() {
        return Math.round(parseFloat(this.monthPay) * 12 * this.loanTen);
      },
      
      // -------------------------- Loan Checker ------------------------
      totalExp() {
        return parseFloat(this.loanchecker_otherS) + parseFloat(this.credCard) + parseFloat(this.persLoan) + parseFloat(this.carInst);
      },
      netIncome() {
        return parseFloat(this.grossIncome) - parseFloat(this.totalExp);
      },
      DSR65() { return Math.round(this.netIncome * 0.65) },
      DSR75() { return Math.round(this.netIncome * 0.75) },
      DSR85() { return Math.round(this.netIncome * 0.85) },
      LA65() { return this.DSR65 * 200 },
      LA75() { return this.DSR75 * 200 },
      LA85() { return this.DSR85 * 200 },
      
      // -------------------------- Legal Fees ------------------------
      feePerc() {
        var feep = 0;
        if (this.propPrice <= 500000) {
          feep = this.propPrice * 0.01;
        }
        if (this.propPrice > 500000 && this.propPrice <= 1000000) {
          feep = 5000 + (this.propPrice - 500000) * 0.008;
        }
        if (this.propPrice > 1000000 && this.propPrice <= 3000000) {
          feep = 9000 + (this.propPrice - 1000000) * 0.007;
        }
        if (this.propPrice > 3000000 && this.propPrice <= 5000000) {
          feep = 23000 + (this.propPrice - 3000000) * 0.006;
        }
        if (this.propPrice > 5000000) {
          feep = 35000 + (this.propPrice - 5000000) * 0.005;
        }
        if (feep < 500) {
          feep = 500;
        }
        return feep
      },
      spLegal() { return Math.round(parseFloat(this.feePerc)) },
      spDuty() {
        var sp = 0;
        if (this.propPrice <= 100000) {
          sp = this.propPrice * 0.01;
        }
        if (this.propPrice > 100000 && this.propPrice <= 500000) {
          sp = 1000 + (this.propPrice - 100000) * 0.02;
        }
        if (this.propPrice > 500000 && this.propPrice <= 1000000) {
          sp = 9000 + (this.propPrice - 500000) * 0.03;
        }
        if (this.propPrice > 1000000) {
          sp = 24000 + (this.propPrice - 1000000) * 0.04;
        }
        return this.isEven(sp)
      },
      spTotal() { return Math.round(parseFloat(this.spLegal) + parseFloat(this.spDuty)) },
      loanLegal() { return Math.round(parseFloat(this.feePerc) * parseFloat(this.moF) / 100) },
      loanDuty() { return this.isEven(parseFloat(this.propPrice) * parseFloat(this.moF) * 0.00005) },
      loanTotal() { return Math.round(parseFloat(this.loanLegal) + parseFloat(this.loanDuty)) },
      grandTotal() { return Math.round(parseFloat(this.spTotal) + parseFloat(this.loanTotal)) },
    },
    methods: {
      addComma: function (num) {
        if (num != null) {
          var num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      isEven: function (n) {
        var num = n;
        if (Math.floor(n) % 2 == 0) { // is even with decimal
          num = Math.round(n)
          if (num % 2 != 0) {
            num = num + 1
          }
        } else { // is odd with decimal
          num = Math.floor(n) + 1;
        }
        return num;
      },
      calculate: function() {
        this.isloaded = false;
        var myDiv = document.getElementById('details-calgroup');
        
        setTimeout(() => {
          myDiv.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.isloaded = true;
        }, 500);
      },
    },
  }
</script>

<!-- CSS styling for this component. The "scoped" attribute limits the styling exclusibely to THIS component-->
<style scoped>
  .cg-subtotal-value {
    color: var(--p4text1, #FFFFFF);
    font-weight: 600;
  }

  .cg-subtotal {
    color: var(--p4text1, #FFFFFF);
    line-height: 1.5;
  }

  .cg-label {
    color: var(--p4text2, #AFAFAF);
    padding-bottom: 10px;
    padding-left: 5px;
  }

  .cg-result-div {
    background: linear-gradient(248.13deg, #D80000 13.44%, #9F0A00 75.3%);
    border-radius: 6px;
    padding: 15px 20px;
    color: #FFFFFF;
  }

  .cg-result-div .cg-result-total {
    font-size: 18px;
  }

  ::placeholder {
    font-size: 12px;
  }

  tr {
    line-height: 18px;
  }

  .DSR {
    color: red !important;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .result {
    font-size: 14px;
    font-weight: bold;
    border: 1px solid rgb(172, 51, 51);
    border-radius: 8px;
    padding: 10px;
  }
  
  td {
    line-height: 28px;
    padding: 5px !important;
    text-align: center;
  }
</style>